// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Ensure styles penetrate view encapsulation */
::ng-deep .custom-accordion .mat-expansion-panel {
    border: none;
    margin: 0;
  }
  
  ::ng-deep .custom-accordion .mat-expansion-panel-header {
    background: #F5F6FA;
    border-bottom: 1px solid #D3D3D3;
    padding: 10px 18px;
    position: relative; /* For positioning the custom arrow */
  }
  
  /* Hide the default Angular Material expansion indicator */
  ::ng-deep .custom-accordion .mat-expansion-panel-header .mat-expansion-indicator {
    display: none;
  }
  
  .custom-accordion .panel-title {
    font-size: 16px;
    font-weight: bold;
    color: #4D4F5C; /* Dark gray text color */
    text-decoration: none;
    display: flex;
    align-items: center;
  }
  
  .custom-accordion .panel-title .accordion-toggle {
    text-decoration: none;
    color: inherit; /* Inherits the color from .panel-title */
    flex-grow: 1;
    margin-right: 10px; /* Adjusts space between title and arrow */
  }
  
  .custom-accordion .custom-dropdown-icon {
    margin-left: 10px; /* Space between the title and the arrow */
    width: 20px;
    height: 19px;
    background: url('/assets/images/panel-arrow.svg') no-repeat center center;
    transition: transform 0.3s ease;
    display: inline-block;
  }
  
  .custom-accordion .custom-dropdown-icon.expanded {
    transform: rotate(90deg); /* Rotate arrow when expanded */
  }
  
  .custom-accordion .listItem {
    padding: 8px 0 8px 50px;
    border-bottom: 1px solid #D3D3D3;
    margin: 0;
  }
  
  .custom-accordion .mat-expansion-panel-content {
    padding: 0;
  }
  
  /* Additional styles for smooth transition */
  ::ng-deep .custom-accordion .mat-expansion-panel-content {
    transition: all 0.5s ease;
  }
  
  .custom-accordion .btn-link:hover,
  .custom-accordion .title:hover {
    text-decoration: none;
  }
  `, "",{"version":3,"sources":["webpack://./src/app/components/customer/intakes/add-intakes-data/basic/content/custom-content/custom-content.component.css"],"names":[],"mappings":"AAAA,+CAA+C;AAC/C;IACI,YAAY;IACZ,SAAS;EACX;;EAEA;IACE,mBAAmB;IACnB,gCAAgC;IAChC,kBAAkB;IAClB,kBAAkB,EAAE,qCAAqC;EAC3D;;EAEA,0DAA0D;EAC1D;IACE,aAAa;EACf;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,cAAc,EAAE,yBAAyB;IACzC,qBAAqB;IACrB,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,qBAAqB;IACrB,cAAc,EAAE,yCAAyC;IACzD,YAAY;IACZ,kBAAkB,EAAE,0CAA0C;EAChE;;EAEA;IACE,iBAAiB,EAAE,0CAA0C;IAC7D,WAAW;IACX,YAAY;IACZ,yEAAyE;IACzE,+BAA+B;IAC/B,qBAAqB;EACvB;;EAEA;IACE,wBAAwB,EAAE,+BAA+B;EAC3D;;EAEA;IACE,uBAAuB;IACvB,gCAAgC;IAChC,SAAS;EACX;;EAEA;IACE,UAAU;EACZ;;EAEA,4CAA4C;EAC5C;IACE,yBAAyB;EAC3B;;EAEA;;IAEE,qBAAqB;EACvB","sourcesContent":["/* Ensure styles penetrate view encapsulation */\n::ng-deep .custom-accordion .mat-expansion-panel {\n    border: none;\n    margin: 0;\n  }\n  \n  ::ng-deep .custom-accordion .mat-expansion-panel-header {\n    background: #F5F6FA;\n    border-bottom: 1px solid #D3D3D3;\n    padding: 10px 18px;\n    position: relative; /* For positioning the custom arrow */\n  }\n  \n  /* Hide the default Angular Material expansion indicator */\n  ::ng-deep .custom-accordion .mat-expansion-panel-header .mat-expansion-indicator {\n    display: none;\n  }\n  \n  .custom-accordion .panel-title {\n    font-size: 16px;\n    font-weight: bold;\n    color: #4D4F5C; /* Dark gray text color */\n    text-decoration: none;\n    display: flex;\n    align-items: center;\n  }\n  \n  .custom-accordion .panel-title .accordion-toggle {\n    text-decoration: none;\n    color: inherit; /* Inherits the color from .panel-title */\n    flex-grow: 1;\n    margin-right: 10px; /* Adjusts space between title and arrow */\n  }\n  \n  .custom-accordion .custom-dropdown-icon {\n    margin-left: 10px; /* Space between the title and the arrow */\n    width: 20px;\n    height: 19px;\n    background: url('/assets/images/panel-arrow.svg') no-repeat center center;\n    transition: transform 0.3s ease;\n    display: inline-block;\n  }\n  \n  .custom-accordion .custom-dropdown-icon.expanded {\n    transform: rotate(90deg); /* Rotate arrow when expanded */\n  }\n  \n  .custom-accordion .listItem {\n    padding: 8px 0 8px 50px;\n    border-bottom: 1px solid #D3D3D3;\n    margin: 0;\n  }\n  \n  .custom-accordion .mat-expansion-panel-content {\n    padding: 0;\n  }\n  \n  /* Additional styles for smooth transition */\n  ::ng-deep .custom-accordion .mat-expansion-panel-content {\n    transition: all 0.5s ease;\n  }\n  \n  .custom-accordion .btn-link:hover,\n  .custom-accordion .title:hover {\n    text-decoration: none;\n  }\n  "],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
